var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestAccessInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 356,
    viewBox: "0 0 356 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1465_4979",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 358,
    height: 358
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.910156,
    y: 64.0234,
    width: 300,
    height: 300,
    rx: 7.8125,
    transform: "rotate(-12.5 -0.910156 64.0234)",
    fill: "url(#paint0_radial_1465_4979)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1465_4979)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.87,
    y: 163.914,
    width: 37.1094,
    height: 37.1094,
    rx: 7.61719,
    transform: "rotate(-12.5 155.87 163.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.506,
    y: 149.648,
    width: 74.6094,
    height: 74.6094,
    rx: 7.61719,
    transform: "rotate(-12.5 133.506 149.648)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.139,
    y: 135.406,
    width: 112.109,
    height: 112.109,
    rx: 7.61719,
    transform: "rotate(-12.5 111.139 135.406)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7798,
    y: 121.156,
    width: 149.609,
    height: 149.609,
    rx: 7.61719,
    transform: "rotate(-12.5 88.7798 121.156)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4126,
    y: 106.914,
    width: 187.109,
    height: 187.109,
    rx: 7.61719,
    transform: "rotate(-12.5 66.4126 106.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.0533,
    y: 92.6718,
    width: 224.609,
    height: 224.609,
    rx: 7.61719,
    transform: "rotate(-12.5 44.0533 92.6718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6861,
    y: 78.4218,
    width: 262.109,
    height: 262.109,
    rx: 7.61719,
    transform: "rotate(-12.5 21.6861 78.4218)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.6772,
    y: 64.1718,
    width: 299.609,
    height: 299.609,
    rx: 7.61719,
    transform: "rotate(-12.5 -0.6772 64.1718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1465_4979)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 154,
    width: 48,
    height: 48,
    rx: 9.30247,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.965,
    y: 154.465,
    width: 47.0698,
    height: 47.0698,
    rx: 8.83735,
    stroke: "#EAECF0",
    strokeWidth: 0.930247,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.5 150C197.572 150 196.682 150.369 196.025 151.025C195.369 151.682 195 152.572 195 153.5V155.5C194.47 155.5 193.961 155.711 193.586 156.086C193.211 156.461 193 156.97 193 157.5V162C193 162.53 193.211 163.039 193.586 163.414C193.961 163.789 194.47 164 195 164H202C202.53 164 203.039 163.789 203.414 163.414C203.789 163.039 204 162.53 204 162V157.5C204 156.97 203.789 156.461 203.414 156.086C203.039 155.711 202.53 155.5 202 155.5V153.5C202 151.567 200.433 150 198.5 150ZM201 155.5V153.5C201 152.837 200.737 152.201 200.268 151.732C199.799 151.263 199.163 151 198.5 151C197.837 151 197.201 151.263 196.732 151.732C196.263 152.201 196 152.837 196 153.5V155.5H201Z",
    fill: "#C13434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.016 168.167C178.877 168.035 178.692 167.961 178.5 167.961C178.308 167.961 178.123 168.035 177.984 168.167C175.861 170.183 173.034 171.288 170.107 171.247C169.948 171.245 169.792 171.293 169.662 171.386C169.532 171.479 169.435 171.61 169.385 171.762C168.963 173.048 168.749 174.393 168.75 175.747C168.75 181.689 172.814 186.68 178.313 188.095C178.436 188.126 178.564 188.126 178.687 188.095C184.186 186.68 188.25 181.689 188.25 175.747C188.25 174.357 188.027 173.017 187.615 171.762C187.565 171.61 187.468 171.478 187.339 171.385C187.209 171.293 187.053 171.244 186.893 171.246L186.75 171.247C183.754 171.247 181.033 170.077 179.016 168.167ZM182.11 176.183C182.17 176.103 182.213 176.012 182.238 175.915C182.262 175.818 182.267 175.717 182.251 175.618C182.236 175.519 182.201 175.424 182.149 175.339C182.096 175.254 182.028 175.18 181.946 175.122C181.865 175.064 181.773 175.023 181.675 175.001C181.578 174.979 181.477 174.977 181.378 174.994C181.28 175.012 181.186 175.049 181.102 175.103C181.018 175.157 180.946 175.228 180.89 175.311L177.654 179.841L176.03 178.217C175.888 178.084 175.7 178.012 175.505 178.015C175.311 178.019 175.126 178.098 174.988 178.235C174.851 178.372 174.772 178.558 174.769 178.752C174.765 178.946 174.838 179.134 174.97 179.277L177.22 181.527C177.297 181.604 177.39 181.663 177.492 181.7C177.594 181.738 177.703 181.753 177.812 181.744C177.92 181.735 178.025 181.702 178.12 181.649C178.215 181.595 178.297 181.521 178.36 181.433L182.11 176.183Z",
    fill: "#011229"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1465_4979",
    x: 152.64,
    y: 148.07,
    width: 55.721,
    height: 56.721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.930247
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.930247
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1465_4979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1465_4979",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1465_4979",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.09 214.023) rotate(90) scale(150 150)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestAccessInsurance);
export default __webpack_public_path__ + "static/media/request_access_insurance.7f5e8f2d0d5dd902501b2177fa120d18.svg";
export { ForwardRef as ReactComponent };